// extracted by mini-css-extract-plugin
export default {"loadingContainer":"OnboardingTeamInviteStep_loadingContainer__XJf-a","inviteFormContainer":"OnboardingTeamInviteStep_inviteFormContainer__YHHLh"};